var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclamationRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.56445C10.2435 1.56445 12.9062 4.1915 12.9062 7.4707C12.9062 10.7326 10.2646 13.377 7 13.377C3.73942 13.377 1.09375 10.7366 1.09375 7.4707C1.09375 4.21125 3.73521 1.56445 7 1.56445ZM7 0.689453C3.25508 0.689453 0.21875 3.72688 0.21875 7.4707C0.21875 11.2167 3.25508 14.252 7 14.252C10.7449 14.252 13.7812 11.2167 13.7812 7.4707C13.7812 3.72688 10.7449 0.689453 7 0.689453ZM6.01562 10.0957H6.34375V6.81445H6.01562C5.83442 6.81445 5.6875 6.66754 5.6875 6.48633V6.26758C5.6875 6.08637 5.83442 5.93945 6.01562 5.93945H7.32812C7.50933 5.93945 7.65625 6.08637 7.65625 6.26758V10.0957H7.98438C8.16558 10.0957 8.3125 10.2426 8.3125 10.4238V10.6426C8.3125 10.8238 8.16558 10.9707 7.98438 10.9707H6.01562C5.83442 10.9707 5.6875 10.8238 5.6875 10.6426V10.4238C5.6875 10.2426 5.83442 10.0957 6.01562 10.0957ZM7 3.5332C6.51675 3.5332 6.125 3.92496 6.125 4.4082C6.125 4.89145 6.51675 5.2832 7 5.2832C7.48325 5.2832 7.875 4.89145 7.875 4.4082C7.875 3.92496 7.48325 3.5332 7 3.5332Z",
    fill: "#0070AA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationRound);
export default __webpack_public_path__ + "static/media/ExclamationRound.442ecc1f.svg";
export { ForwardRef as ReactComponent };